import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../components/header'
import UserMenu from '../components/userMenu'
import Toast from './sub_components/toast'
import * as profitLossService from '../services/profitLossService'
import Currency from './sub_components/currency'
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { casinoList } from '../configs/casinoShowList';
import * as _ from 'lodash'
import * as authUtil from "../util/auth.util";
class ProfitLoss extends Component {
    csvLink = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            pnl_datanew: {},
            totalnew: 0,
            from: "",
            to: "",
            accounts: "",
            client_id: "",
            usersList: [],
            toastMsg: "",
            toastType: "",
            showToast: false,
            showData: false,
            loader: false,
            isPnlData: false,
            eventNameById: { "1": "Soccer", "2": "Tennis", "4": "Cricket", "400": "Kabaddi", "500": "Election", "7": "Horse Racing", "4339": "Greyhound Racing" }
        };
    }
    componentDidMount() {
        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        if (!(!!userData && !!userData.sub)) {
            authUtil.logout(true);
        }
        let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        this.setState({ accounts: userData.sub, to: curDate, from: weekDate })
    }
    parseToPickerDate(date) {
        let dtArr = date.split("/")
        let dt = dtArr[2] + "-" + (dtArr[0].split("").length === 2 ? dtArr[0] : "0" + dtArr[0]) + "-" + (dtArr[1].split("").length === 2 ? dtArr[1] : "0" + dtArr[1])
        return dt
    }
    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }
    updateMaintanence(status) {
        this.setState({ isMaintanance: status })
    }
    parseFilterBody() {
        let body = {
            //"user_id": this.state.accounts,
            "from": new Date(this.state.from).toISOString(),
            "to": new Date(this.state.to).toISOString(),
        }
        body = this.clean(body);
        return body
    }
    async submitForm() {
        const self = this;
        let body = this.parseFilterBody()
        this.setState({ loader: true })
        await profitLossService.postProfitLoss(body).then((res) => {
            let pnl_newdata = {
                "MATCH_ODDS_4": { et: "4", sport: "Cricket", mt: "MATCH_ODDS", bt: "ODDS", pnl_commission: 0 },
                "TIED_MATCH_4": { et: "4", sport: "Cricket", mt: "TIED_MATCH", bt: "ODDS", pnl_commission: 0 },
                "COMPLETED_MATCH_4": { et: "4", sport: "Cricket", mt: "COMPLETED_MATCH", bt: "ODDS", pnl_commission: 0 },
                "BOOKMAKER_4": { et: "4", sport: "Cricket", mt: "BOOKMAKER", bt: "BOOKMAKER", pnl_commission: 0 },
                "SPECIAL_MAKER_4": { et: "4", sport: "Cricket", mt: "SPECIAL_MAKER", bt: "BOOKMAKER", pnl_commission: 0 },
                "MINI_BOOKMAKER_4": { et: "4", sport: "Cricket", mt: "MINI_BOOKMAKER", bt: "BOOKMAKER", pnl_commission: 0 },
                "FANCY_4": { et: "4", sport: "Cricket", mt: "FANCY", bt: "LINE", pnl_commission: 0 },
                "LINE_4": { et: "4", sport: "Cricket", mt: "LINE", bt: "LINE", pnl_commission: 0 },
                "WINNING_ODDS_4": { et: "4", sport: "Cricket", mt: "WINNING_ODDS", bt: "ODDS", pnl_commission: 0 },
                "SUPER_OVER_4":{et:"4", sport:"Cricket", mt:"SUPER_OVER", bt:"ODDS", pnl_commission: 0},
                "MATCH_ODDS_1": { et: "1", sport: "Soccer", mt: "MATCH_ODDS", bt: "ODDS", pnl_commission: 0 },
                "BOOKMAKER_1": { et: "1", sport: "Soccer", mt: "BOOKMAKER", bt: "BOOKMAKER", pnl_commission: 0 },
                "SPECIAL_MAKER_1": { et: "1", sport: "Soccer", mt: "SPECIAL_MAKER", bt: "BOOKMAKER", pnl_commission: 0 },
                "OVER_UNDER_85_1":{et:"1", sport:"Soccer", mt:"OVER_UNDER_85", bt:"ODDS", pnl_commission: 0},
                "OVER_UNDER_75_1":{et:"1", sport:"Soccer", mt:"OVER_UNDER_75", bt:"ODDS", pnl_commission: 0},
                "OVER_UNDER_65_1":{et:"1", sport:"Soccer", mt:"OVER_UNDER_65", bt:"ODDS", pnl_commission: 0},
                "OVER_UNDER_55_1":{et:"1", sport:"Soccer", mt:"OVER_UNDER_55", bt:"ODDS", pnl_commission: 0},
                "OVER_UNDER_45_1":{et:"1", sport:"Soccer", mt:"OVER_UNDER_45", bt:"ODDS", pnl_commission: 0},
                "OVER_UNDER_35_1": { et: "1", sport: "Soccer", mt: "OVER_UNDER_35", bt: "ODDS", pnl_commission: 0 },
                "OVER_UNDER_25_1": { et: "1", sport: "Soccer", mt: "OVER_UNDER_25", bt: "ODDS", pnl_commission: 0 },
                "OVER_UNDER_15_1": { et: "1", sport: "Soccer", mt: "OVER_UNDER_15", bt: "ODDS", pnl_commission: 0 },
                "OVER_UNDER_05_1": { et: "1", sport: "Soccer", mt: "OVER_UNDER_05", bt: "ODDS", pnl_commission: 0 },
                "MINI_BOOKMAKER_1": { et: "1", sport: "Soccer", mt: "MINI_BOOKMAKER", bt: "BOOKMAKER", pnl_commission: 0 },
                "WINNING_ODDS_1": { et: "1", sport: "Soccer", mt: "WINNING_ODDS", bt: "ODDS", pnl_commission: 0 },
                "MATCH_ODDS_2": { et: "2", sport: "Tennis", mt: "MATCH_ODDS", bt: "ODDS", pnl_commission: 0 },
                "SET_WINNER_2": { et: "2", sport: "Tennis", mt: "SET_WINNER", bt: "ODDS", pnl_commission: 0 },
                "BOOKMAKER_2": { et: "2", sport: "Tennis", mt: "BOOKMAKER", bt: "BOOKMAKER", pnl_commission: 0 },
                "SPECIAL_MAKER_2": { et: "2", sport: "Tennis", mt: "SPECIAL_MAKER", bt: "BOOKMAKER", pnl_commission: 0 },
                "MINI_BOOKMAKER_2": { et: "2", sport: "Tennis", mt: "MINI_BOOKMAKER", bt: "BOOKMAKER", pnl_commission: 0 },
                "WINNING_ODDS_2": { et: "2", sport: "Tennis", mt: "WINNING_ODDS", bt: "ODDS", pnl_commission: 0 },
                "WIN_7": { et: "7", sport: "Horse Racing", mt: "WIN", bt: "ODDS", pnl_commission: 0 },
                "WIN_4339": { et: "4339", sport: "Greyhound Racing", mt: "WIN", bt: "ODDS", pnl_commission: 0 },
                "BOOKMAKER_400": { et: "400", sport: "Kabaddi", mt: "BOOKMAKER", bt: "BOOKMAKER", pnl_commission: 0 },
                "SPECIAL_MAKER_400": { et: "400", sport: "Kabaddi", mt: "SPECIAL_MAKER", bt: "BOOKMAKER", pnl_commission: 0 },
                "WINNING_ODDS_400": { et: "400", sport: "Kabaddi", mt: "WINNING_ODDS", bt: "ODDS", pnl_commission: 0 },
                "BOOKMAKER_500": { et: "500", sport: "Election", mt: "BOOKMAKER", bt: "BOOKMAKER", pnl_commission: 0 },
                "SPECIAL_MAKER_500": { et: "500", sport: "Election", mt: "SPECIAL_MAKER", bt: "BOOKMAKER", pnl_commission: 0 },
                "FANCY_500": { et: "500", sport: "Election", mt: "FANCY", bt: "LINE", pnl_commission: 0 },
                "WINNING_ODDS_500": { et: "500", sport: "Election", mt: "WINNING_ODDS", bt: "ODDS", pnl_commission: 0 },
                "DAILY_300": { et: "300", sport: "Binary", mt: "DAILY", bt: "LINE", pnl_commission: 0 },
                "1_HOUR_300": { et: "300", sport: "Binary", mt: "1_HOUR", bt: "LINE", pnl_commission: 0 },
                "2_HOUR_300": { et: "300", sport: "Binary", mt: "2_HOUR", bt: "LINE", pnl_commission: 0 },
                // "INDIAN_POKER_99": { et: "99", sport: "Casino", mt: "INDIAN_POKER", bt: "LOTUS", pnl_commission: 0 },
                // "INDIAN_POKER_2_99": { et: "99", sport: "Casino", mt: "INDIAN_POKER_2", bt: "SUPERNOVA", pnl_commission: 0 },
                // "CASINO_99": { et: "99", sport: "Casino", mt: "CASINO", bt: "DRC || QTECH", pnl_commission: 0 },
                // "EVOLUTION_99": { et: "99", sport: "Casino", mt: "EVOLUTION", bt: "ODDS", pnl_commission: 0 },
                // "DIGITAIN_999": { et: "999", sport: "SportBook", mt: "SPORTBOOK", bt: "ODDS", pnl_commission: 0 }
            }


            for(const itm of Object.values(casinoList)){
                if(itm.provider !== ""){
                    if( ["CASINO_III_99", "INDIAN_POKER/LIVE_CASINO_99"].includes(itm.pnlLabel) ){
                        if(!(!!pnl_newdata[itm.pnlLabel])){
                            pnl_newdata[itm.pnlLabel] = {et:"99", sport:"Casino", mt:itm.mt, bt:itm.bt, pnl_commission: 0};
                        }
                    } else {
                        pnl_newdata[itm.pnlLabel] = {et:"99", sport:"Casino", mt:itm.mt, bt:itm.bt, pnl_commission: 0};
                    }
                }
             }
    
             pnl_newdata["DIGITAIN_999"] = {et:"999", sport:"SportBook", mt:"SPORTBOOK", bt:"ODDS", pnl_commission: 0};

            if (res.isSuccess) {
                self.setState(
                    {
                        pnl_datanew: {},
                        totalnew: 0,
                        isPnlData: false,
                    }, () => {

                        let totalnew = 0

                        res.items.forEach((it) => {

                            if ((it._id.bt === "ODDS" || it._id.bt === "BOOKMAKER") && it._id.et !== "99" && it._id.et !== "999") {
                                if(!!pnl_newdata[`${it._id.mt}_${it._id.et}`]){
                                    pnl_newdata[`${it._id.mt}_${it._id.et}`].pnl_commission += it.pnl + it.commission
                                    totalnew += it.pnl + it.commission
                                }
                            }
                            else if (it._id.bt === "LINE" && it._id.provider !== "BETFAIR" && it._id.et === "4") {
                                if(!!pnl_newdata[`FANCY_${it._id.et}`]){
                                    pnl_newdata[`FANCY_${it._id.et}`].pnl_commission += it.pnl + it.commission
                                    totalnew += it.pnl + it.commission
                                }
                            }
                            else if (it._id.bt === "LINE" && it._id.provider === "BETFAIR" && it._id.et === "4") {
                                if(!!pnl_newdata[`LINE_${it._id.et}`]){
                                    pnl_newdata[`LINE_${it._id.et}`].pnl_commission += it.pnl + it.commission
                                    totalnew += it.pnl + it.commission
                                }
                            }
                            else if (it._id.bt === "LINE" && it._id.et === "500") {
                                if(!!pnl_newdata[`FANCY_${it._id.et}`]){
                                    pnl_newdata[`FANCY_${it._id.et}`].pnl_commission += it.pnl + it.commission
                                    totalnew += it.pnl + it.commission
                                }
                            }
                            else if (it._id.mt === "DAILY" && it._id.et === "300") {
                                if(!!pnl_newdata[`DAILY_${it._id.et}`]){
                                    pnl_newdata[`DAILY_${it._id.et}`].pnl_commission += it.pnl + it.commission
                                    totalnew += it.pnl + it.commission
                                }
                            }
                            else if (it._id.mt === "1_HOUR" && it._id.et === "300") {
                                if(!!pnl_newdata[`1_HOUR_${it._id.et}`]){
                                    pnl_newdata[`1_HOUR_${it._id.et}`].pnl_commission += it.pnl + it.commission
                                    totalnew += it.pnl + it.commission
                                }
                            }
                            else if (it._id.mt === "2_HOUR" && it._id.et === "300") {
                                if(!!pnl_newdata[`2_HOUR_${it._id.et}`]){
                                    pnl_newdata[`2_HOUR_${it._id.et}`].pnl_commission += it.pnl + it.commission
                                    totalnew += it.pnl + it.commission
                                }
                            }
                            else if(it._id.et === "99"){
                                //let obj = pnl_newdata[`${it._id.provider}_${it._id.et}`];
                                // const objkey = `${(it._id.provider === "LOTUS" ? "INDIAN_POKER_II" : (it._id.provider === "SUPERNOVA" ? "INDIAN_POKER_II" : (it._id.provider === "DRC" || it._id.provider === "QTECH" ? "CASINO" :(it._id.provider === "DRCROYAL"? "INDIAN_POKER/LIVE_CASINO" : (it._id.provider === "DRCHUD"? "CASINO_III" : it._id.provider)))))}_${it._id.et}`
                                const objkey = `${(it._id.provider === "LOTUS" ? "INDIAN_POKER_II" : (it._id.provider === "SUPERNOVA" ? "INDIAN_POKER_II" : (it._id.provider === "DRC" || it._id.provider === "QTECH" ? "CASINO" :(it._id.provider === "DRCROYAL"? "INDIAN_POKER/LIVE_CASINO" :(it._id.provider === "DRCHUD"? "CASINO_III" : ( it._id.provider === "MAC88" ? "EVOLUTION" : it._id.provider))))))}_${it._id.et}`
                                if(!!pnl_newdata[objkey]){
                                    pnl_newdata[objkey].pnl_commission += it.pnl + it.commission;
                                    totalnew += it.pnl + it.commission;
                                }
                            }
                            else if (it._id.provider === "DIGITAIN") {
                                pnl_newdata[`DIGITAIN_999`].pnl_commission += it.pnl + it.commission
                                totalnew += it.pnl + it.commission
                            }
                            // else if (it._id.provider === "LOTUS") {
                            //     pnl_newdata[`INDIAN_POKER_99`].pnl_commission += it.pnl + it.commission
                            //     totalnew += it.pnl + it.commission
                            // }
                            // else if (it._id.provider === "SUPERNOVA") {
                            //     pnl_newdata[`INDIAN_POKER_2_99`].pnl_commission += it.pnl + it.commission
                            //     totalnew += it.pnl + it.commission
                            // }
                            // else if (it._id.provider === "DRC" || it._id.provider === "QTECH") {
                            //     pnl_newdata[`CASINO_99`].pnl_commission += it.pnl + it.commission
                            //     totalnew += it.pnl + it.commission
                            // }
                            // else if (it._id.provider === "EVOLUTION") {
                            //     pnl_newdata[`EVOLUTION_99`].pnl_commission += it.pnl + it.commission
                            //     totalnew += it.pnl + it.commission
                            // }
                            // else if (it._id.provider === "DIGITAIN") {
                            //     pnl_newdata[`DIGITAIN_999`].pnl_commission += it.pnl + it.commission
                            //     totalnew += it.pnl + it.commission
                            // }
                        })

                        this.setState({ pnl_datanew: pnl_newdata, totalnew: totalnew, isPnlData: res.items.length > 0 ? true : false, showData: true, loader: false })
                    }
                );
            } else {
                this.setState({ pnl_datanew: {}, totalnew: 0, isPnlData: false, showData: true, loader: false })
            }
        })
    }
    async onDownload() {
        const self = this;
        let body = this.parseFilterBody()
        // await profitLossService.postProfitLossCsv(body).then((res) => {
        //     this.setState({ csv_json: res }, () => {
        //         setTimeout(function () {
        //             self.csvLink.current.link.click();
        //         }, 500)

        //     })
        // })
    }
    clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === undefined) {
                delete obj[propName];
            }
        }
        return obj
    }
    resetForm() {
        let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        this.setState({ from: weekDate, to: curDate, isPnlData: false, showData: false, pnl_data: [], pnl_search_data: [], total_pnl: 0, totalLotus: 0, totalSupernova: 0, totalDRC: 0, totalFancy: 0, totalLine: 0, totalElectionFancy: 0, totalKabaddiFancy: 0 })
    }
    onSubmit(e) {
        let diffTime = Math.abs(new Date(this.state.to) - new Date(this.state.from))
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays > 31) {
            this.props.notify("Date range must be 1 month.", "error")
        }
        else {
            this.setState({ action: "", page_no: 1 }, () => { this.submitForm(); });
        }
    }
    onChange(e) {
        const name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });
    }
    onDateTimeChange(name, e) {
        this.setState({ [name]: e._d })
    }
    onSearch(e) {
        const value = e.target.value;
        if (this.state.pnl_search_data) {
            let pnl_lst = _.filter(this.state.pnl_search_data, function (obj) {
                return JSON.stringify(obj).toLowerCase().indexOf(value.toLowerCase()) !== -1;
            });
            this.setState({ pnl_data: [] }, () => {
                this.setState({ pnl_data: pnl_lst });
            })
        }
    }

    render() {
        let total = this.state.totalFancy + this.state.totalLine + this.state.totalLotus + this.state.totalSupernova + this.state.totalDRC + this.state.totalElectionFancy + this.state.totalKabaddiFancy
        return (
            <div className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) =>this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} updateMaintanence={(status) => { this.updateMaintanence(status) }} />
                <div className="full-wrap">
                    <UserMenu history={this.props.history} isMaintanance={this.state.isMaintanance} />
                    <div className="col-center1 markets">
                        <div className="mar-top100">
                            <div className="sub_path center-box mt-2">
                                <p>Profit &amp; Loss Report</p>
                            </div>
                            <div className="allreport col3">
                                <div className="row mx-0">
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 mt-2">
                                        <div className="form-group font-12">
                                            <Datetime
                                                key={"fromDate"}
                                                value={this.state.from}
                                                onChange={(e) => this.onDateTimeChange("from", e)}
                                                id="from_datetime"
                                                dateFormat={"DD/MM/YYYY"}
                                                timeFormat={"HH:mm"}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 mt-2">
                                        <div className="form-group font-12">
                                            <Datetime
                                                key={"toDate"}
                                                value={this.state.to}
                                                onChange={(e) => this.onDateTimeChange("to", e)}
                                                id="to_datetime"
                                                dateFormat={"DD/MM/YYYY"}
                                                timeFormat={"HH:mm"}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2 mb-3 mt-2">
                                        <div className="btn-group" role="group" aria-label="Basic example" id="divpagecount">
                                            <button className="btn place-bet-btn" onClick={(e) => this.onSubmit(e)}>Go</button>
                                            <button className="btn place-bet-btn ml-1" onClick={(e) => this.resetForm()}>Reset</button>
                                        </div>
                                    </div>
                                </div>
                                {!this.state.showData && !!this.state.loader ? <div className={"ml-2"}>Loading......</div> : null}
                                {!!this.state.showData && <div>
                                    <div className="dt-responsive table-responsive account-statment p-2">
                                        <table id="basic-btn" className="table table-bordered nowrap table-sm mb-1 addpadding">
                                            <thead>
                                                <tr className="bg-dark text-white">
                                                    <th className="wid165 pthead">Sport</th>
                                                    <th className="pthead">Market Name</th>
                                                    <th className="pthead text-right">Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody id="tblAccountStatement">
                                                {!!this.state.loader ?
                                                    <tr>
                                                        <td colSpan={17} className="text-center py-5">
                                                            <h5 className="text-dark font-weight-bold m-0"> Loading...... </h5>
                                                        </td>
                                                    </tr> :
                                                    this.state.isPnlData ? <>
                                                        {Object.keys(this.state.pnl_datanew).length > 0 && Object.keys(this.state.pnl_datanew).map((sprt, i) => {
                                                            const sport = this.state.pnl_datanew[sprt]
                                                            return (<>
                                                                {!!sport.pnl_commission &&
                                                                    <tr key={i}>
                                                                        <td>{!!sport.et ? sport.sport : ""}</td>
                                                                        <td>{!!sport.mt ? (sport.mt === 'WINNING_ODDS' ? 'LOTTERY' : sport.mt.split("_").join(" ")) : ""}</td>
                                                                        <td className="text-right fbold"><Currency key={"pnl_amt_" + i} classPropName={sport.pnl_commission > 0 ? "text-right text-success fbold" : sport.pnl_commission < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={!!sport.pnl_commission ? sport.pnl_commission : 0} showColor={false} /></td>
                                                                    </tr>
                                                                }

                                                            </>);
                                                        })
                                                        }
                                                        {!!this.state.totalnew &&
                                                            <tr>
                                                                <td colSpan={2} className="fbold">Total</td>
                                                                <td className="text-right fbold"><Currency key={"pnl_total"} classPropName={this.state.totalnew > 0 ? "text-right text-success fbold" : this.state.totalnew < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={!!this.state.totalnew ? this.state.totalnew : 0} showColor={false} /></td>
                                                            </tr>}
                                                    </>
                                                        :
                                                        <tr>
                                                            <td colSpan={8} className="text-center py-5"><h5 className="text-danger font-weight-bold m-0">No Profit &amp; Loss Found</h5></td>
                                                        </tr>
                                                }
                                                {/* this.state.pnl_data.length > 0 ? this.state.pnl_data.map((sport, i) => {
                                                        if (!sport.amount) {
                                                            return false
                                                        }
                                                        return (<tr>
                                                            <td>{!!sport.eventTypeName ? sport.eventTypeName === "CASINO" ? "Casino" : sport.eventTypeName : ""}</td>
                                                            <td>{!!sport.marketName ? sport.marketName : sport.marketType.replaceAll("_", " ")}</td>
                                                            <td className="text-right fbold"><Currency key={"amt_" + i} classPropName={sport.amount > 0 ? "text-right text-success fbold" : sport.amount < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={!!sport.amount ? sport.amount : "0"} showColor={false} /></td>
                                                        </tr>);
                                                    }) :
                                                        <tr>
                                                            <td colSpan={8} className="text-center py-5"><h5 className="text-danger font-weight-bold m-0">No Profit &amp; Loss Found</h5></td>
                                                        </tr>}
                                                {!!this.state.total_pnl &&
                                                    <tr>
                                                        <td className="fbold" colSpan={2}>Total</td>
                                                        <td className="text-right fbold"><Currency key={"pnl"} classPropName={this.state.total_pnl > 0 ? "text-right text-success fbold" : this.state.total_pnl < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={!!this.state.total_pnl ? this.state.total_pnl : "0"} showColor={false} /></td>
                                                    </tr>
                                                } */}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                    {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ProfitLoss);